import { AppError } from './app-error';

export class IneligibleError extends AppError {

}